import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-title m-0" }
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope fs-3" }, null, -1)
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_36 = { class: "col-lg-8 fv-row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fs-3" }, null, -1)
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_42 = { class: "col-lg-8 fv-row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_44 = { class: "pb-5" }
const _hoisted_45 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_46 = { class: "row mb-6" }
const _hoisted_47 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_48 = { class: "col-lg-8 fv-row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-3" }, null, -1)
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "col-lg-8 fv-row" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "row mb-6" }
const _hoisted_58 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_59 = { class: "col-lg-8 fv-row" }
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_62 = { class: "col-lg-8 fv-row" }
const _hoisted_63 = { class: "fv-plugins-message-container" }
const _hoisted_64 = { class: "fv-help-block" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_66 = { class: "pb-5" }
const _hoisted_67 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_68 = { class: "row mb-6" }
const _hoisted_69 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_70 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_71 = { class: "fv-plugins-message-container" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_74 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_75 = { class: "col-lg-8 fv-row" }
const _hoisted_76 = { class: "fv-plugins-message-container" }
const _hoisted_77 = { class: "fv-help-block" }
const _hoisted_78 = { class: "row mb-6" }
const _hoisted_79 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_80 = { class: "col-lg-8 fv-row" }
const _hoisted_81 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_82 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_83 = { class: "col-lg-5 fv-row fv-plugins-icon-container" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_88 = { class: "card mb-5 mb-xl-10" }
const _hoisted_89 = { class: "card-header border-0" }
const _hoisted_90 = { class: "card-title m-0" }
const _hoisted_91 = { class: "fw-bolder m-0" }
const _hoisted_92 = { class: "collapse show" }
const _hoisted_93 = { class: "card-body border-top p-9" }
const _hoisted_94 = { class: "row mb-6" }
const _hoisted_95 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_96 = { class: "col-lg-8 fv-row" }
const _hoisted_97 = { class: "row mb-6" }
const _hoisted_98 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_99 = { class: "col-lg-8 fv-row" }
const _hoisted_100 = { class: "row mb-6" }
const _hoisted_101 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_102 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_103 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_104 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_105 = { class: "col-lg-8 fv-row" }
const _hoisted_106 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_107 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_108 = { class: "col-lg-8 fv-row" }
const _hoisted_109 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_110 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_111 = { class: "col-lg-8 fv-row" }
const _hoisted_112 = { class: "fv-plugins-message-container" }
const _hoisted_113 = { class: "fv-help-block" }
const _hoisted_114 = { class: "row mb-6" }
const _hoisted_115 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_116 = { class: "col-lg-8 fv-row" }
const _hoisted_117 = {
  key: 3,
  class: "row mb-6"
}
const _hoisted_118 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_119 = { class: "col-lg-8 fv-row" }
const _hoisted_120 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_121 = { class: "col-lg-4 fv-row fv-plugins-icon-container" }
const _hoisted_122 = { class: "col-lg-4 fv-row fv-plugins-icon-container" }
const _hoisted_123 = { class: "col-lg-3 fv-row fv-plugins-icon-container" }
const _hoisted_124 = ["onClick"]
const _hoisted_125 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_128 = { class: "row mb-6" }
const _hoisted_129 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_130 = { class: "col-lg-8 fv-row" }
const _hoisted_131 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_132 = { class: "col-lg-10 fv-row fv-plugins-icon-container d-inline-block align-middle" }
const _hoisted_133 = ["download", "href"]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_135 = ["onClick"]
const _hoisted_136 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_137 = [
  _hoisted_136
]
const _hoisted_138 = { class: "row mb-6" }
const _hoisted_139 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_140 = { class: "col-lg-8 fv-row d-none" }
const _hoisted_141 = {
  class: "dropzone",
  id: "kt_dropzonejs_nuevos_documentos"
}
const _hoisted_142 = { class: "dz-message needsclick" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-3x" }, null, -1)
const _hoisted_144 = { class: "ms-4" }
const _hoisted_145 = { class: "fs-5 fw-bolder text-gray-900 mb-1" }
const _hoisted_146 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_147 = { class: "card mb-5 mb-xl-10" }
const _hoisted_148 = { class: "card-header border-0" }
const _hoisted_149 = { class: "card-title m-0" }
const _hoisted_150 = { class: "fw-bolder m-0" }
const _hoisted_151 = { class: "collapse show" }
const _hoisted_152 = { class: "card-body border-top p-9" }
const _hoisted_153 = { class: "row mb-6" }
const _hoisted_154 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_155 = { class: "col-lg-8 fv-row" }
const _hoisted_156 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_157 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_158 = { class: "col-lg-5 fv-row fv-plugins-icon-container" }
const _hoisted_159 = ["onClick"]
const _hoisted_160 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_161 = [
  _hoisted_160
]
const _hoisted_162 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)
const _hoisted_163 = { class: "row" }
const _hoisted_164 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_165 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_166 = { class: "row" }
const _hoisted_167 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_168 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_169 = { class: "row" }
const _hoisted_170 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_171 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_172 = { class: "row" }
const _hoisted_173 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_174 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_175 = { class: "row mb-6" }
const _hoisted_176 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_177 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_178 = { class: "row mb-6" }
const _hoisted_179 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_180 = { class: "col-lg-8 fv-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_ServiciosTabla = _resolveComponent("ServiciosTabla")!
  const _component_ServiciosColectivosTabla = _resolveComponent("ServiciosColectivosTabla")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Page, { showBack: "" }, _createSlots({
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, { type: "border-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.profesionalDetalle.listadoGroup')
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.listadoGroup")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.claseEstado)
                    }, _toDisplayString(_ctx.estado), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_el_select, {
                          name: "tratamiento",
                          class: "w-100",
                          modelValue: _ctx.tratamiento,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tratamiento) = $event)),
                          disabled: true
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tratamientos, (tratamiento, i) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: i,
                                label: tratamiento.text,
                                value: tratamiento.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_ErrorMessage, { name: "tratamiento" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.nombre.label")), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "nombre",
                              placeholder: " ",
                              modelValue: _ctx.nombre,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombre) = $event)),
                              disabled: true
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_ErrorMessage, { name: "nombre" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "apellidos",
                              placeholder: " ",
                              modelValue: _ctx.apellidos,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apellidos) = $event)),
                              disabled: true
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_ErrorMessage, { name: "apellidos" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.dni.label")), 1),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "dni",
                          placeholder: " ",
                          modelValue: _ctx.dni,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dni) = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_ErrorMessage, { name: "dni" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.email.label")), 1),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "email",
                          placeholder: " ",
                          modelValue: _ctx.email,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                          disabled: true
                        }, {
                          append: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_ErrorMessage, { name: "email" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.telefono.label")), 1),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "telefono",
                          placeholder: " ",
                          modelValue: _ctx.telefono,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telefono) = $event)),
                          disabled: true
                        }, {
                          append: _withCtx(() => [
                            _hoisted_37
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_ErrorMessage, { name: "telefono" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.fechaNacimiento.label")), 1),
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_el_date_picker, {
                          format: "DD/MM/YYYY",
                          modelValue: _ctx.fechaNacimiento,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fechaNacimiento) = $event)),
                          disabled: true,
                          type: "date",
                          "disabled-date": _ctx.disabledDate,
                          class: "w-100"
                        }, null, 8, ["modelValue", "disabled-date"])
                      ])
                    ]),
                    _hoisted_43,
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("h4", _hoisted_45, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.direccionGroup")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.direccion.label")), 1),
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "direccion",
                          placeholder: " ",
                          modelValue: _ctx.direccion,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.direccion) = $event)),
                          disabled: true
                        }, {
                          append: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_ErrorMessage, { name: "direccion" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.localidad.label")), 1),
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "localidad",
                          placeholder: " ",
                          modelValue: _ctx.localidad,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localidad) = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createVNode(_component_ErrorMessage, { name: "localidad" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.comarca.label")), 1),
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_el_select, {
                          "_:disabled": "!isAdmin",
                          modelValue: _ctx.comarcaId,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.comarcaId) = $event)),
                          disabled: true,
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.text,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.provincia.label")), 1),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "provincia",
                          placeholder: " ",
                          modelValue: _ctx.provincia,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.provincia) = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("div", _hoisted_64, [
                            _createVNode(_component_ErrorMessage, { name: "provincia" })
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_65,
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("h4", _hoisted_67, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.otrosDatos")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.carnetConducir.label")), 1),
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.carnetConducir,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.carnetConducir) = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_component_ErrorMessage, { name: "carnetConducir" })
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.carnetConducir)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.vehiculoPropio.label")), 1),
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.vehiculo,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.vehiculo) = $event)),
                              disabled: true,
                              class: "w-100",
                              placeholder: 
                      _ctx.$t('formularios.profesionalDetalle.vehiculoPropio.label')
                    
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehiculos, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.nombre,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"]),
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("div", _hoisted_77, [
                                _createVNode(_component_ErrorMessage, { name: "vehiculo" })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.idiomas.label")), 1),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("ul", _hoisted_81, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.idiomas, (idioma, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              class: "row"
                            }, [
                              _createElementVNode("div", _hoisted_82, [
                                _createVNode(_component_el_select, {
                                  modelValue: idioma.nombreIdioma,
                                  "onUpdate:modelValue": ($event: any) => ((idioma.nombreIdioma) = $event),
                                  disabled: true,
                                  class: "w-100",
                                  placeholder: 
                            _ctx.$t('formularios.profesionalDetalle.idiomas.nombre')
                          
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nombreIdioma, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _createElementVNode("div", _hoisted_83, [
                                _createVNode(_component_el_select, {
                                  modelValue: idioma.nivel,
                                  "onUpdate:modelValue": ($event: any) => ((idioma.nivel) = $event),
                                  disabled: true,
                                  class: "w-100",
                                  placeholder: 
                            _ctx.$t('formularios.profesionalDetalle.idiomas.nivel')
                          
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nivel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "col-1 btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                onClick: ($event: any) => (_ctx.removeIdioma(i)),
                                disabled: true
                              }, _hoisted_86, 8, _hoisted_84)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.addIdioma && _ctx.addIdioma(...args))),
                          disabled: true
                        }, [
                          _hoisted_87,
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.profesionalDetalle.idiomas.nuevoIdioma")), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.cargaDetalle]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.profesionalDetalle.datosProfesionalGroup')
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("h3", _hoisted_91, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.datosProfesionalGroup")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.comarcasTrabajo.label")), 1),
                      _createElementVNode("div", _hoisted_96, [
                        _createVNode(_component_el_select, {
                          name: "comarcasTrabajoIds",
                          modelValue: _ctx.comarcasTrabajoIds,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.comarcasTrabajoIds) = $event)),
                          disabled: true,
                          multiple: "",
                          class: "w-100",
                          placeholder: 
                      _ctx.$t('formularios.profesionalDetalle.comarcasTrabajo.label')
                    
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.text,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.comarcasSolicitaTrabajo.label"
                    )), 1),
                      _createElementVNode("div", _hoisted_99, [
                        _createVNode(_component_el_select, {
                          name: "comarcasSolicitaTrabajoIds",
                          modelValue: _ctx.comarcasSolicitaTrabajoIds,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.comarcasSolicitaTrabajoIds) = $event)),
                          disabled: "",
                          multiple: "",
                          class: "w-100",
                          placeholder: 
                      _ctx.$t(
                        'formularios.profesionalDetalle.comarcasSolicitaTrabajo.label'
                      )
                    
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.text,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.disponeTitulacion.label")), 1),
                      _createElementVNode("div", _hoisted_102, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.disponeTitulacion,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.disponeTitulacion) = $event)),
                          disabled: true,
                          onChange: _ctx.changeDisponeTitulacion,
                          "active-color": ""
                        }, null, 8, ["modelValue", "onChange"])
                      ])
                    ]),
                    (_ctx.disponeTitulacion)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                          _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.titulacion.label")), 1),
                          _createElementVNode("div", _hoisted_105, [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.titulacion,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.titulacion) = $event)),
                              disabled: true,
                              multiple: "",
                              class: "w-100",
                              placeholder: 
                      _ctx.$t('formularios.profesionalDetalle.titulaciones.label')
                    
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titulaciones, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.text,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.disponeTitulacion)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                          _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.titulacionOtras.label")), 1),
                          _createElementVNode("div", _hoisted_108, [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.titulacion,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.titulacion) = $event)),
                              disabled: true,
                              multiple: "",
                              class: "w-100",
                              placeholder: 
                      _ctx.$t('formularios.profesionalDetalle.titulaciones.label')
                    
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sinTitulaciones, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.text,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "placeholder"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showOtrasTitulaciones)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                          _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.detalleTitulacionOtras.label"
                    )), 1),
                          _createElementVNode("div", _hoisted_111, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "titulacionOtras",
                              placeholder: 
                      _ctx.$t('formularios.profesionalDetalle.titulacionOtras.label')
                    ,
                              modelValue: _ctx.titulacionOtras,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.titulacionOtras) = $event)),
                              disabled: true
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_112, [
                              _createElementVNode("div", _hoisted_113, [
                                _createVNode(_component_ErrorMessage, { name: "titulacionOtras" })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.experienciaCuidadoMenores.label"
                    )), 1),
                      _createElementVNode("div", _hoisted_116, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.experienciaCuidadoMenores,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.experienciaCuidadoMenores) = $event)),
                          disabled: true,
                          class: "w-100",
                          placeholder: 
                      _ctx.$t(
                        'formularios.profesionalDetalle.experienciaCuidadoMenores.label'
                      )
                    
                        }, {
                          default: _withCtx(() => [
                            (_ctx.disponeTitulacion)
                              ? (_openBlock(), _createBlock(_component_el_option, {
                                  key: 0,
                                  value: "EXPERIENCIAPROFESIONAL",
                                  label: 
                        _ctx.$t('experienciaCuidadoMenores.EXPERIENCIAPROFESIONAL')
                      
                                }, null, 8, ["label"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_option, {
                              value: "EXPERIENCIANOPROFESIONAL",
                              label: 
                        _ctx.$t('experienciaCuidadoMenores.EXPERIENCIANOPROFESIONAL')
                      
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              value: "SINEXPERIENCIA",
                              label: _ctx.$t('experienciaCuidadoMenores.SINEXPERIENCIA')
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ])
                    ]),
                    (
                  _ctx.experienciaCuidadoMenores != 'SINEXPERIENCIA' &&
                  _ctx.experienciaCuidadoMenores != ''
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                          _createElementVNode("label", _hoisted_118, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.experiencia.label")), 1),
                          _createElementVNode("div", _hoisted_119, [
                            _createElementVNode("ul", _hoisted_120, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experiencia, (ele, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: i,
                                  class: "row"
                                }, [
                                  _createElementVNode("div", _hoisted_121, [
                                    _createVNode(_component_el_input, {
                                      type: "text",
                                      placeholder: 
                            _ctx.$t(
                              'formularios.profesionalDetalle.experiencia.tipo.label'
                            )
                          ,
                                      modelValue: ele.tipo,
                                      "onUpdate:modelValue": ($event: any) => ((ele.tipo) = $event),
                                      disabled: true
                                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_122, [
                                    _createVNode(_component_el_input, {
                                      type: "text",
                                      placeholder: 
                            _ctx.$t(
                              'formularios.profesionalDetalle.experiencia.dirigidoA.label'
                            )
                          ,
                                      modelValue: ele.dirigidoA,
                                      "onUpdate:modelValue": ($event: any) => ((ele.dirigidoA) = $event),
                                      disabled: true
                                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_123, [
                                    _createVNode(_component_el_input, {
                                      type: "text",
                                      placeholder: 
                            _ctx.$t(
                              'formularios.profesionalDetalle.experiencia.duracion.label'
                            )
                          ,
                                      modelValue: ele.duracion,
                                      "onUpdate:modelValue": ($event: any) => ((ele.duracion) = $event),
                                      disabled: true
                                    }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "col-1 btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                    onClick: ($event: any) => (_ctx.removeExperiencia(i)),
                                    disabled: true
                                  }, _hoisted_126, 8, _hoisted_124)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.addExperiencia && _ctx.addExperiencia(...args))),
                              disabled: true
                            }, [
                              _hoisted_127,
                              _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.profesionalDetalle.experiencia.nuevaExperiencia"
                      )), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_128, [
                      _createElementVNode("label", _hoisted_129, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.documentos.label")), 1),
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("ul", _hoisted_131, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentos, (file, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              class: "el-upload-list__item is-success",
                              tabindex: "0"
                            }, [
                              _createElementVNode("div", _hoisted_132, [
                                _createElementVNode("a", {
                                  class: "el-upload-list__item-name",
                                  download: `${_ctx.nombre}${_ctx.apellidos}${file.tipo}-${file.nombre}`,
                                  href: file.blob
                                }, [
                                  _createVNode(_component_el_image, {
                                    class: "align-middle",
                                    style: {"width":"100px","height":"100px"},
                                    src: file.blob,
                                    fit: "cover"
                                  }, {
                                    error: _withCtx(() => [
                                      _hoisted_134
                                    ]),
                                    _: 2
                                  }, 1032, ["src"]),
                                  _createTextVNode(" " + _toDisplayString(file.nombre), 1)
                                ], 8, _hoisted_133)
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "col-1 d-inline-block btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                onClick: ($event: any) => (_ctx.removeDocumento(i)),
                                disabled: true
                              }, _hoisted_137, 8, _hoisted_135)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("label", _hoisted_139, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.nuevosDocumentos.label")), 1),
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("div", _hoisted_141, [
                          _createElementVNode("div", _hoisted_142, [
                            _hoisted_143,
                            _createElementVNode("div", _hoisted_144, [
                              _createElementVNode("h3", _hoisted_145, _toDisplayString(_ctx.$t(
                              "formularios.profesionalDetalle.nuevosDocumentos.accion"
                            )), 1),
                              _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.$t(
                            "formularios.profesionalDetalle.nuevosDocumentos.descripcion"
                          )), 1)
                            ])
                          ])
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          name: "certificadoAntecedentes",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.cargaDetalle]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.profesionalDetalle.disponibilidadGroup')
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_147, [
                _createElementVNode("div", _hoisted_148, [
                  _createElementVNode("div", _hoisted_149, [
                    _createElementVNode("h3", _hoisted_150, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.disponibilidadGroup")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_151, [
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("label", _hoisted_154, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.disponibilidad.diasyhoras"
                    )), 1),
                      _createElementVNode("div", _hoisted_155, [
                        _createElementVNode("ul", _hoisted_156, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disponibilidadesArray, (tiempo, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              class: "row"
                            }, [
                              _createElementVNode("div", _hoisted_157, [
                                _createVNode(_component_el_select, {
                                  modelValue: tiempo.dias,
                                  "onUpdate:modelValue": ($event: any) => ((tiempo.dias) = $event),
                                  disabled: true,
                                  class: "w-100",
                                  multiple: "",
                                  placeholder: 
                            _ctx.$t('formularios.profesionalDetalle.dias.label')
                          
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dias, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _createElementVNode("div", _hoisted_158, [
                                _createVNode(_component_el_select, {
                                  modelValue: tiempo.horas,
                                  "onUpdate:modelValue": ($event: any) => ((tiempo.horas) = $event),
                                  disabled: true,
                                  class: "w-100",
                                  multiple: "",
                                  placeholder: 
                            _ctx.$t('formularios.profesionalDetalle.horarios.label')
                          
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horarios, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "col-1 btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                onClick: ($event: any) => (_ctx.removeHorario(i)),
                                disabled: true
                              }, _hoisted_161, 8, _hoisted_159)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                          onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addHorario && _ctx.addHorario(...args))),
                          disabled: true
                        }, [
                          _hoisted_162,
                          _createTextVNode(_toDisplayString(_ctx.$t(
                        "formularios.profesionalDetalle.disponibilidad.nuevaDisponibilidad"
                      )), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_163, [
                      _createElementVNode("label", _hoisted_164, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.laborables.label")), 1),
                      _createElementVNode("div", _hoisted_165, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.laborables,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.laborables) = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_166, [
                      _createElementVNode("label", _hoisted_167, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.finesDeSemana.label")), 1),
                      _createElementVNode("div", _hoisted_168, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.finesDeSemana,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.finesDeSemana) = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("label", _hoisted_170, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.festivos.label")), 1),
                      _createElementVNode("div", _hoisted_171, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.festivos,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.festivos) = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("label", _hoisted_173, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.urgencias.label")), 1),
                      _createElementVNode("div", _hoisted_174, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.urgencias,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.urgencias) = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_175, [
                      _createElementVNode("label", _hoisted_176, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.noches.label")), 1),
                      _createElementVNode("div", _hoisted_177, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.noches,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.noches) = $event)),
                          disabled: true
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_178, [
                      _createElementVNode("label", _hoisted_179, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.detalleDisponibilidad.label"
                    )), 1),
                      _createElementVNode("div", _hoisted_180, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.detalleDisponibilidad,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.detalleDisponibilidad) = $event)),
                          disabled: true,
                          rows: 3,
                          autosize: { minRows: 2 },
                          type: "textarea",
                          placeholder: " "
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.cargaDetalle]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.servicios.length)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: _ctx.$t('formularios.profesionalDetalle.servicios'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ServiciosTabla, { servicios: _ctx.servicios }, null, 8, ["servicios"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.serviciosColectivos.length)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 1,
                label: _ctx.$t('formularios.familiaDetalle.serviciosColectivos'),
                lazy: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ServiciosColectivosTabla, { servicios: _ctx.serviciosColectivos }, null, 8, ["servicios"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (!_ctx.isAdmin)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            _createVNode(_component_el_dropdown, { class: "mx-3" }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { onClick: _ctx.incorporarProfesional }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("formularios.profesionalCA.acciones.incluir")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "default" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                    _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_arrow_down)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        }
      : undefined
  ]), 1024))
}